import { useCallback, useState } from 'react';
import { AInput, AModal, ASelect, ATitle } from '../../../components';
import { IGuide, IPaymentMethod } from '../../../shared/interfaces';
import { DollarOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import { useToast } from '../../../hooks/toast';
import { schemaFinancial } from '../../Financials/schemas/yup.financial.schema';
import api from '../../../services/api';

interface IGenerateFinancialProps {
  open: boolean;
  close: () => void;
  guide: IGuide | null;
  payments: IPaymentMethod[];
  setGuides: React.Dispatch<React.SetStateAction<IGuide[]>>;
}
const GenerateFinancial: React.FC<IGenerateFinancialProps> = ({
  open,
  close,
  guide,
  payments,
  setGuides,
}) => {
  const { addToast } = useToast();
  const [payment_date, setPayment_date] = useState<string>();
  const [payment_method, setPayment_method] = useState<string>();

  const handleGenerateFinancial = useCallback(() => {
    if (!guide) return;

    if (!payment_date || !payment_method) {
      addToast({
        type: 'warning',
        title: 'Aviso',
        description: 'Preencha todos os campos!',
      });
      return;
    }

    schemaFinancial
      .validate({
        issue_date: new Date().toLocaleDateString('fr-CA'),
        due_date: payment_date,
        financial_plan_id: null,
        client_id: guide?.client_id,
        description: `RECEBIMENTO REF. GUIA ID ${guide.code}`,
        observation: `GUIA Nº ${guide.guide_number ?? guide.code}`,
        value: +guide.value,
        type: 1,
        payment: payment_method,
        payment_date: payment_date,
        number_doc: guide.code,
        status: 2,
        quantity_installments: 1,
        repeat_value: false,
      })
      .then(async (formValidated: any) => {
        await api
          .patch(`/guides/financial/${guide.id}`, formValidated)
          .then(async (response) => {
            setGuides((state: IGuide[]) =>
              state.map((e) => (e.id !== response.data.id ? e : response.data)),
            );
            addToast({
              type: 'success',
              title: 'Sucesso',
              description: 'Conta(s) cadastrada(s) com sucesso',
            });
            close();
          })
          .catch((error) => {
            addToast({
              type: 'error',
              title: 'Erro',
              description: `${
                error.response.data.error ?? 'Erro ao cadastrar.'
              }`,
            });
          });
      })
      .catch((err) => {
        addToast({
          type: 'error',
          title: 'Campos em branco',
          description: err.errors,
        });
        return;
      });
  }, [payment_method, payment_date, guide]);

  return (
    <AModal
      open={open}
      close={close}
      title={
        <>
          <DollarOutlined /> Gerar Financeiro
        </>
      }
      onOk={handleGenerateFinancial}
      width={800}
      okText={'Sim'}
      cancelText={'Não'}
    >
      <ATitle level={5}>Gerar conta à receber da guia Nº {guide?.code}</ATitle>
      <Form layout="vertical">
        <Form.Item label="Data Pagamento" required>
          <AInput
            value={payment_date}
            type="date"
            onChange={(e) => setPayment_date(e.target.value)}
          />
        </Form.Item>
        <Form.Item label="Forma de Pagamento" required>
          <ASelect
            value={payment_method}
            placeholder="Selecione a forma de pagamento"
            onChange={(e) => setPayment_method(e)}
            allowClear
            options={payments.map((fin) => ({
              label: fin.description,
              value: fin.id,
            }))}
          />
        </Form.Item>
      </Form>
    </AModal>
  );
};

export default GenerateFinancial;
